import React from 'react'

const SongwriterMyWritersHeader = () => (
    <>
        <p>
            This page lists all your writer names and the songs associated with each, helping you easily view and manage
            your catalog
        </p>
    </>
)

export default SongwriterMyWritersHeader
